import {
    ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS,
    FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS,
    FETCH_PROJECT_BUS_PRIORITY_SUCCESS,
    FILTER_PROJECT_BUS_PRIORITY,
    GET_ALL_PROJECT_BUS_PRIORITY,
    GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY,
    HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE,
    HIDE_PROJECT_BUS_PRIORITY_LOADER,
    SHOW_PROJECT_BUS_PRIORITY_LOADER,
    ON_ADD_PROJECT_BUS_PRIORITY,
    ON_EDIT_PROJECT_BUS_PRIORITY,
    ON_ALL_PROJECT_BUS_PRIORITY_SELECT,
    ON_PROJECT_BUS_PRIORITY_CLOSE,
    ON_PROJECT_BUS_PRIORITY_SELECT,
    ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS,
    ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY,
    ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT,
    ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS,
    ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER,
    SHOW_PROJECT_BUS_PRIORITY_MESSAGE,
    UPDATE_SEARCH_PROJECT_BUS_PRIORITY,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All Priorities';
export const STARRED_FILTER = 'Starred priorities';
export const SUCCESSFUL_UPDATE = 'Priorities Updated Successfully';
export const SUCCESSFUL_FILTER = 'Priorities Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Priorities Deleted Successfully';
export const REMOVED_AS_STAR = 'Priorities removed as star';
export const MARKED_AS_STAR = 'Priorities marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No priorities found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allProjectBusPriority: [],
    projectBusPriorityList: [],
    selectedProjectBusPriority: null,
    selectedProjectBusPrioritys: 0,
    addProjectBusPriorityState: false,
    editProjectBusPriorityState: false,
    searchProjectBusPriority: '',
    projectBusPriority: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedProjectBusPriority: null,
            };
        }
        case ADD_FAVOURITE_PROJECT_BUS_PRIORITY_SUCCESS: {
            const allUpdated = state.allProjectBusPriority.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                projectBusPriorityList: listUpdated,
                allProjectBusPriority: allUpdated,
            };
        }
        case FETCH_PROJECT_BUS_PRIORITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedProjectBusPriority: action.payload,
                addProjectBusPriorityState: false,
                editProjectBusPriorityState: false,
            };
        }
        case FETCH_ALL_PROJECT_BUS_PRIORITY_SUCCESS: {
            return {
                ...state,
                loader: false,
                allProjectBusPriority: action.payload,
                projectBusPriorityList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addProjectBusPriorityState: false,
                editProjectBusPriorityState: false,
            };
        }
        case SHOW_PROJECT_BUS_PRIORITY_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_PROJECT_BUS_PRIORITY_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedProjectBusPrioritys = 0;
            const projectBusPriorityList = state.projectBusPriorityList.map(projectBusPriority => {
                if (projectBusPriority.selected) {
                    selectedProjectBusPrioritys++;
                }
                if (projectBusPriority.id === action.payload.id) {
                    if (projectBusPriority.selected) {
                        selectedProjectBusPrioritys++;
                    }
                    return action.payload;
                } else {
                    return projectBusPriority;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedProjectBusPrioritys: selectedProjectBusPrioritys,
                projectBusPriorityList: projectBusPriorityList
            };
        }
        case ON_ADD_PROJECT_BUS_PRIORITY: {
            return {
                ...state,
                addProjectBusPriorityState: true,
                editProjectBusPriorityState: false,
            };
        }
        case ON_EDIT_PROJECT_BUS_PRIORITY: {
            return {
                ...state,
                selectedProjectBusPriority: action.payload,
                editProjectBusPriorityState: true,
                addProjectBusPriorityState: false,
            };
        }
        case ON_PROJECT_BUS_PRIORITY_CLOSE: {
            return {
                ...state,
                addProjectBusPriorityState: false,
                editProjectBusPriorityState: false,
            };
        }
        case ON_FILTER_PROJECT_BUS_PRIORITY_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let projectBusPriorityList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectBusPriorityList = state.allProjectBusPriority;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    projectBusPriorityList = state.allProjectBusPriority.filter((projectBusPriority) => projectBusPriority.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, projectBusPriorityList, drawerState: false
            };
        }
        case ON_SAVE_PROJECT_BUS_PRIORITY_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                projectBusPriorityList: addOrUpdateEntry(state.projectBusPriorityList, action.payload),
                allProjectBusPriority: addOrUpdateEntry(state.allProjectBusPriority, action.payload),
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_PROJECT_BUS_PRIORITY_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allProjectBusPriority: state.allProjectBusPriority.filter((projectBusPriority) => projectBusPriority.id !== action.payload),
                projectBusPriorityList: state.allProjectBusPriority.filter((projectBusPriority) => projectBusPriority.id !== action.payload),
            };
        }
        case ON_FILTER_SELECTED_PROJECT_BUS_PRIORITY: {
            const projectBusPrioritys = state.allProjectBusPriority.filter((projectBusPriority) => !projectBusPriority.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                projectBusPriorityList: projectBusPrioritys,
                selectedProjectBusPrioritys: 0
            };
        }
        case FILTER_PROJECT_BUS_PRIORITY: {
            const { filterOption } = state;
            let projectBusPriorityList = [];
            if (action.payload === '') {
                projectBusPriorityList = state.allProjectBusPriority;
            } else {
                const filterProjectBusPriority = state.allProjectBusPriority.filter((projectBusPriority) =>
                    projectBusPriority.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    projectBusPriorityList = filterProjectBusPriority;
                } else if (filterOption === STARRED_FILTER) {
                    projectBusPriorityList = filterProjectBusPriority.filter((projectBusPriority) => projectBusPriority.starred);
                }
            }
            return { ...state, projectBusPriorityList: projectBusPriorityList };
        }
        case GET_ALL_PROJECT_BUS_PRIORITY: {
            let projectBusPriorityList = state.allProjectBusPriority.map((projectBusPriority) => projectBusPriority ? {
                ...projectBusPriority,
                selected: true
            } : projectBusPriority);
            return {
                ...state,
                selectedProjectBusPrioritys: projectBusPriorityList.length,
                allProjectBusPriority: projectBusPriorityList,
                projectBusPriorityList: projectBusPriorityList
            };
        }
        case GET_UNSELECTED_ALL_PROJECT_BUS_PRIORITY: {
            let projectBusPriorityList = state.allProjectBusPriority.map((projectBusPriority) => projectBusPriority ? {
                ...projectBusPriority,
                selected: false
            } : projectBusPriority);
            return {
                ...state,
                selectedProjectBusPrioritys: 0,
                allProjectBusPriority: projectBusPriorityList,
                projectBusPriorityList: projectBusPriorityList
            };
        }
        case ON_ALL_PROJECT_BUS_PRIORITY_SELECT: {
            const selectAll = state.selectedProjectBusPrioritys < state.projectBusPriorityList.length;
            let selectedProjectBusPrioritys = 0;
            let projectBusPriorityList = [];
            if (selectAll) {
                projectBusPriorityList = state.allProjectBusPriority.map((projectBusPriority) => projectBusPriority ? {
                    ...projectBusPriority,
                    selected: true
                } : projectBusPriority);
                selectedProjectBusPrioritys = projectBusPriorityList.length;
            } else {
                projectBusPriorityList = state.allProjectBusPriority.map((projectBusPriority) => projectBusPriority ? {
                    ...projectBusPriority,
                    selected: true
                } : projectBusPriority);
                selectedProjectBusPrioritys = 0;
            }
            return {
                ...state,
                selectedProjectBusPrioritys: selectedProjectBusPrioritys,
                allProjectBusPriority: projectBusPriorityList,
                projectBusPriorityList: projectBusPriorityList
            };
        }
        case UPDATE_SEARCH_PROJECT_BUS_PRIORITY: {
            return { ...state, searchProjectBusPriority: action.payload };
        }
        case HANDLE_PROJECT_BUS_PRIORITY_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PROJECT_BUS_PRIORITY_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PROJECT_BUS_PRIORITY_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PROJECT_BUS_PRIORITY_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/projectBusPriority.js